import * as React from 'react';

function SvgSearchIcon(props) {
  return (
    <svg
      width={14}
      height={14}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.664 11.836L10.5 9.689a5.25 5.25 0 10-.811.811l2.147 2.147a.582.582 0 00.828 0 .583.583 0 000-.811zM6.416 10.5a4.083 4.083 0 110-8.166 4.083 4.083 0 010 8.166z"
        fill="#232340"
      />
    </svg>
  );
}

export default SvgSearchIcon;
